// extracted by mini-css-extract-plugin
export var detail = "shield-recommender-module--detail--53b38";
export var fflogo = "shield-recommender-module--fflogo--8d520";
export var rec = "shield-recommender-module--rec--23626";